import React from 'react';
import { Box } from '@mui/material';

const MainCard = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      bgcolor="#fff"
      border="1px solid #b4bcc2"
      borderRadius="4px"
      margin="0px 64px 80px 64px"
      padding="32px"
      gap="24px"
      maxWidth="1920px"
    >
      {children}
    </Box>
  );
};

export default MainCard;
